module.exports = __webpack_public_path__ + "img/9788996792987.57840021.jpg";